export default class ns {
  constructor(t) {
    (this.productId = t), (this.productId = t);
  }
  xc(t) {
    return null == this.productId || t[0] === this.productId;
  }
  static fromJson(t) {
    return new ns(t ? t.product_id : null);
  }
  bt() {
    return this.productId;
  }
}
